// src/tabs/calendar/_outbox-helpers.js — Pricing hybride LOT 5
//
// Helpers purs (testables sans React) pour l'alerte de désynchronisation
// tarifaire : transforme la liste plate des entrées pricing_outbox NON
// confirmées (renvoyée par l'action read-only `pricing_outbox_pending_read`)
// en structures consommables par le calendrier prix :
//   - une Map<logement_id, Map<dateISO, status>> pour poser le ⚠️ par case,
//   - le nombre total d'entrées non confirmées pour l'encart de tête.
//
// Convention plage outbox : date_from → date_to INCLUS aux deux bornes
// (cohérent avec le push Beds24 `{ from, to }` du drain). On itère donc
// date_from..date_to inclus.

function toISODateLocal(d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
    d.getDate(),
  ).padStart(2, "0")}`
}

/**
 * Construit la Map<logement_id, Map<dateISO, status>> des dates couvertes par
 * un push outbox non confirmé.
 *
 * @param {Array<{logement_id:string, date_from:string, date_to:string, status:string}>} items
 * @returns {Map<string, Map<string, string>>} vide si items vide/invalide.
 */
export function buildOutboxPendingByLogement(items) {
  const out = new Map()
  if (!Array.isArray(items)) return out
  for (const it of items) {
    if (!it || !it.logement_id || !it.date_from) continue
    const from = new Date(it.date_from)
    // date_to optionnel → réservation d'1 jour (from seul).
    const to = it.date_to ? new Date(it.date_to) : new Date(it.date_from)
    if (Number.isNaN(from.getTime()) || Number.isNaN(to.getTime())) continue
    if (to < from) continue
    let inner = out.get(it.logement_id)
    if (!inner) {
      inner = new Map()
      out.set(it.logement_id, inner)
    }
    const cur = new Date(from)
    cur.setHours(0, 0, 0, 0)
    const end = new Date(to)
    end.setHours(0, 0, 0, 0)
    // Garde anti-boucle infinie : borne raisonnable (2 ans).
    let guard = 0
    while (cur <= end && guard < 800) {
      const key = toISODateLocal(cur)
      // Première entrée gagne (peu importe : le statut sert juste le tooltip).
      if (!inner.has(key)) inner.set(key, it.status || "pending")
      cur.setDate(cur.getDate() + 1)
      guard++
    }
  }
  return out
}

/**
 * Nombre d'entrées outbox non confirmées (pour l'encart « X push non confirmés »).
 * @param {Array} items
 * @returns {number}
 */
export function countOutboxPending(items) {
  return Array.isArray(items) ? items.length : 0
}
